import { c as _c } from "react/compiler-runtime";
import { formatCurrency } from "@/libs/utils";
import { DestinationRowDestination, DestinationRowPrice, StyledDestinationSlide, TitleH1, TitleH2 } from "@/styles/destination-slide";
import Image from "next/image";
const DestinationRow = t0 => {
  const $ = _c(13);
  const {
    row
  } = t0;
  const t1 = row.has_shade_destination ? row.shade_color_destination : undefined;
  let t2;
  if ($[0] !== row.destination_color || $[1] !== row.id.label || $[2] !== t1) {
    t2 = <DestinationRowDestination $shade={t1} $color={row.destination_color}>{row.id.label}</DestinationRowDestination>;
    $[0] = row.destination_color;
    $[1] = row.id.label;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = row.has_shade_price ? row.shade_color_price : undefined;
  const t4 = row.price_color;
  let t5;
  if ($[4] !== row.price) {
    t5 = formatCurrency(row.price);
    $[4] = row.price;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== row.price_color || $[7] !== t3 || $[8] !== t5) {
    t6 = <DestinationRowPrice $shade={t3} $color={t4}>od {t5}</DestinationRowPrice>;
    $[6] = row.price_color;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t6) {
    t7 = <div>{t2}{t6}</div>;
    $[10] = t2;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
const DestinationSlide = t0 => {
  const $ = _c(24);
  const {
    slide
  } = t0;
  const t1 = slide.orientation;
  const t2 = slide.attributes.position?.value ?? "left";
  const t3 = `https://www.alexandria.cz/${slide.attributes.filePath}`;
  let t4;
  if ($[0] !== t3) {
    t4 = <Image fill={true} alt="" src={t3} priority={true} />;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = slide.attributes.has_shade_title_1 ? slide.attributes.shade_color_title_1 : undefined;
  let t6;
  if ($[2] !== slide.attributes.color_title_1 || $[3] !== slide.attributes.title_1 || $[4] !== slide.orientation || $[5] !== t5) {
    t6 = <TitleH1 $orientation={slide.orientation} $shade={t5} $color={slide.attributes.color_title_1}>{slide.attributes.title_1}</TitleH1>;
    $[2] = slide.attributes.color_title_1;
    $[3] = slide.attributes.title_1;
    $[4] = slide.orientation;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = slide.attributes.has_shade_title_2 ? slide.attributes.shade_color_title_2 : undefined;
  const t8 = slide.attributes.position?.value ?? "left";
  let t9;
  if ($[7] !== slide.attributes.color_title_2 || $[8] !== slide.attributes.title_2 || $[9] !== slide.orientation || $[10] !== t7 || $[11] !== t8) {
    t9 = <TitleH2 $orientation={slide.orientation} $shade={t7} $color={slide.attributes.color_title_2} $position={t8}>{slide.attributes.title_2}</TitleH2>;
    $[7] = slide.attributes.color_title_2;
    $[8] = slide.attributes.title_2;
    $[9] = slide.orientation;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== slide.attributes.rows) {
    t10 = slide.attributes.rows.map(_temp);
    $[13] = slide.attributes.rows;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t6 || $[17] !== t9) {
    t11 = <div>{t6}{t9}{t10}</div>;
    $[15] = t10;
    $[16] = t6;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== slide.orientation || $[20] !== t11 || $[21] !== t2 || $[22] !== t4) {
    t12 = <StyledDestinationSlide $orientation={t1} $position={t2}>{t4}{t11}</StyledDestinationSlide>;
    $[19] = slide.orientation;
    $[20] = t11;
    $[21] = t2;
    $[22] = t4;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};
export default DestinationSlide;
function _temp(row, index) {
  return <DestinationRow key={index} row={row} />;
}